export default __webpack_public_path__ + "static/media/gallery-image-5.bce088b4.jpg";